export const RANGE_PRESET_MIN_WIDTH = 189;
export const TIME_PRESET_MIN_WIDTH = 135;
export const PRESETS_MAX_HEIGHT = 273;
